<txtb-drawer
  #drawerComponent
  [contentWrapperBehaviour]="indexShown ? 'full-width' : 'expand'"
  [actionId]="action.id"
  [textbookPageId]="action.textbookPageId"
  [textbookId]="action.textbookId"
  [actionContentCollapsed]="actionContentCollapsed"
  [minimizeArrowVisible]="minimizeArrowVisible"
  (contentCollapse)="contentCollapse($event)"
  [groupInfo]="groupInfo"
  [zoomFeatureAvailable]="true"
  (actionDrawerApiInitialized)="onActionDrawerApiInitialized($event)"
>
  <article main class="gallery-index" *ngIf="indexShown">
    <ng-container *ngFor="let image of images; let imgIndex = index">
      <div class="img-wrapper">
        <txtb-image-wrapper
          style="height: 100%; width: 100%"
          [attr.sub]="imageSrc$(image.image.resourceId, imgIndex) | async"
          [fluid]="true"
          [fixRender]="false"
          [proportionalRender]="false"
          [alt]="image.title"
          [src]="imageSrc[imgIndex]"
          [imgSrc]="imageSrc[imgIndex]"
          [style.pointer-events]="(drawerComponent?.drawingByPointerMove$ | async) ? 'none' : 'inherit'"
          [imagesScalingEnabled]="!!action.meta?.imagesScalingEnabled"
          (click)="showFullImg(imgIndex + 1)"
        ></txtb-image-wrapper>
      </div>
    </ng-container>
  </article>
  <article main class="gallery-image" *ngIf="!indexShown">
    <txtb-image-wrapper
      style="height: 100%; width: 100%"
      [attr.sub]="imageSrc$(images[activeElement - 1].image.resourceId, activeElement - 1) | async"
      [proportionalRender]="true"
      [fixRender]="true"
      [alt]="images[activeElement - 1].title"
      [src]="imageSrc[activeElement - 1]"
      [imgSrc]="imageSrc[activeElement - 1]"
      [scrollDisabled]="(drawerComponent?.drawingByPointerMove$ | async) === true"
      [horizontalScroll]="images[activeElement - 1].image?.horizontalScroll"
      [verticalScroll]="images[activeElement - 1].image?.verticalScroll"
      [isScrolled]="images[activeElement - 1].image?.horizontalScroll
        || images[activeElement - 1].image?.verticalScroll"
      [imagesScalingEnabled]="!!action.meta?.imagesScalingEnabled"
      [percentageScale]="images[activeElement - 1].image?.percentageScale || null"
    ></txtb-image-wrapper>
  </article>

  <section footer class="bottom-ui" *ngIf="!indexShown && galleryLength > 1">
    <txtb-paginator
      [activeElement]="activeElement"
      [subSectionLength]="this.images.length"
      (changeElement)="changeElement($event)"
      class="paginator"
    ></txtb-paginator>
    <button class="show-index" (click)="showAll()">Wszystkie</button>
  </section>
</txtb-drawer>
